import { render, staticRenderFns } from "./SeoBlogArticle.vue?vue&type=template&id=32053833&scoped=true&"
import script from "./SeoBlogArticle.vue?vue&type=script&lang=js&"
export * from "./SeoBlogArticle.vue?vue&type=script&lang=js&"
import style0 from "./SeoBlogArticle.vue?vue&type=style&index=0&id=32053833&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32053833",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
